import { useState } from 'react'
import { CircularButton } from '@/components/button/CircularButton'
import { H3 } from '@/components/label/H3'

interface Props {
  title: string
  body: string
}
export const AuthorDetail: React.FC<Props> = ({ title, body }) => {
  const [show, setShow] = useState(false)
  const onClick = () => {
    setShow(!show)
  }
  return (
    <>
      <H3 title={title} />
      <div
        className={`px-[10px] sm:p-0 mt-[10px] text-justify ${
          !show && 'h-14 overflow-hidden text-ellipsis whitespace-nowrap'
        }`}
        dangerouslySetInnerHTML={{ __html: body }}
      ></div>
      <p className="mt-5 text-right">
        <CircularButton
          text={show ? '閉じる' : 'すべてを見る'}
          onClick={onClick}
        />
      </p>
    </>
  )
}
